module.exports = __webpack_public_path__ + "static/media/1.a0a90b23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ywc15-news/1.jpg
// module id = 149
// module chunks = 0